/** TODO: Remove this function when Safari fixes the bug.
 * https://desygner-team.slack.com/archives/C01KD2D15C1/p1672987247327579
 */

export function getUserAgent () {
  return navigator.userAgent;
}

export function isSafari () {
  return /^((?!chrome|android).)*safari/i.test(getUserAgent().toLowerCase());
}

export function isIOSDevice () {
  return /iphone|ipod|ipad/.test(getUserAgent().toLowerCase());
}

export function triggerCanvasRedraw () {
  const elements = document.querySelectorAll('#svgcontent [clip-path], #svgcontent clipPath');
  elements.forEach(element => { element.style.display = 'none'; });

  INKIVE.Helpers.afterRendering(() => {
    elements.forEach(element => { element.style.display = ''; });
  });
}

export function addSafariFallbackListeners () {
  if (!isSafari() && !isIOSDevice()) return;

  INKIVE.EditorFacade.on('editor.loaded', triggerCanvasRedraw);
  INKIVE.EditorFacade.on('page.saved', triggerCanvasRedraw);

  /**
   * Safari has a bug that causes the clipPath to not be updated when the canvas is resized.
   * We need to trigger a redraw of the canvas to fix this.
   * SetTimeout was added to avoid triggering the redraw while the canvas is being resized.
   */
  INKIVE.EditorFacade.on('zoom.changed', () => setTimeout(triggerCanvasRedraw, 10));
  INKIVE.EditorFacade.on('canvas.relativeSize', () => setTimeout(triggerCanvasRedraw, 10));
}
